import { atRoundEnd, defineGameCard } from '../authoring/index.js';
import { residueStacks, slimeDependencies, trail } from './slime-helpers.js';
export const MnemoslimeCard = defineGameCard({
    id: 'mnemoslime',
    gameplay: { type: 'UNIT', cost: 3, baseStats: { attack: 1, health: 3 }, traits: ['SLIME'] },
    presentation: {
        name: 'Мнемослизень',
        description: 'След 1. В конце каждого раунда, если находится в ячейке со Склизью, возьмите 1 карту.',
        glyph: {
            colors: ['#10213A', '#803AA2', '#AF5CBF', '#A453BA', '#A453BA'],
            rows: [
                '.....11......11.....',
                '....121......121....',
                '.....111.....11.....',
                '......121...11......',
                '.......121.121......',
                '.......121.121......',
                '.......1211131......',
                '......12333331......',
                '......13133331......',
                '......13333131......',
                '.....1233333331.....',
                '.....1233333331.....',
                '.....1233333331.....',
                '.....1233333331.....',
                '.....22333333331....',
                '....122333333331....',
                '..1122222433333311..',
                '.122222222222224421.',
                '12222222222222224221',
                '.111111111111111111.',
            ],
        },
    },
    role: 'playable',
    dependencies: slimeDependencies(),
    abilities: [
        trail(),
        atRoundEnd((ctx) => {
            const self = ctx.self;
            if (self?.cellId === undefined || ctx.q.unitAt(self.cellId)?.id !== self.id)
                return;
            if (residueStacks(ctx, self.cellId) >= 1)
                ctx.ops.drawCard(self.controllerId, 1);
        }),
    ],
    ui: { mechanics: ['trail', 'slime_residue'] },
});
//# sourceMappingURL=mnemoslime.js.map